import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';
import { cn } from '@/lib/format';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center py-12 px-6',
        className,
      )}
    >
      <div className="w-12 h-12 rounded-full bg-line/40 flex items-center justify-center text-neutral mb-4">
        {icon ?? <Inbox size={24} strokeWidth={1.5} />}
      </div>
      <h3 className="text-subhead font-display font-semibold text-ink">{title}</h3>
      {description && (
        <p className="text-small text-ink-subtle mt-1.5 max-w-sm">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
